<div class="popup-header">

    <h2>{{claimChartTitle}}</h2>
    <div class="popup-buttons">
        <button mat-raised-button color="primary" class="save-button" (click)="onSave()">Save</button>
        <button class="cross-btn" (click)="onCancel()"><i class="material-icons">close</i></button>
    </div>
</div>
<div class="table-container">

    <table class="edit-claim-table">
        <thead>
            <tr>
                <th>Claim Element</th>
                <th>Infringement</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let claimElement of editableClaimData; let i = index">
                <td>
                    <div class="editable-cell-wrapper" [class.expanded]="isExpanded[i].claim">
                        <div class="editable-cell-content pseudo-editor" [innerHTML]="generateClaimHTML(claimElement)" (blur)="handleClaimElementBlur($event, i)">
                        </div>
                        <!-- <button class="expand-btn" (click)="toggleExpand(i, 'claim')">
            <svg *ngIf="isExpanded[i].claim " width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.25 11.25H24.75V15.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.75 24.75H11.25V20.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M24.75 11.25L19.5 16.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.25 24.75L16.5 19.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                 <svg *ngIf="!isExpanded[i].claim" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24 16.5L19.5 16.5L19.5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 19.5L16.5 19.5L16.5 24" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5 16.5L24.75 11.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.5 19.5L11.25 24.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 
          </button> -->
                    </div>
                </td>
                <td>
                    <div class="editable-cell-wrapper" [class.expanded]="isExpanded[i].infringement">
                        <div class="editable-cell-content pseudo-editor" contenteditable="true" (input)="onChange($event)" [innerHTML]="generateInfringementHTML(claimElement)" (blur)="handleInfringementBlur($event, i)">
                            <div class="indvidual-part-claim-element">
                                <b>Analyst Comment: </b> {{claimElement.analyst_comment}}
                            </div>
                            <div class="individual-part-claim-element">
                                <div><b>References:</b> <span *ngIf="claimElement.references.length==0"></span> </div>
                                <div *ngFor="let reference of claimElement.references">
                                    <div>{{reference.reference}}</div>
                                </div>
                            </div>
                            <div class="individual-part-claim-element">
                                <div><b>Sources:</b></div>
                                <ng-container *ngFor="let reference of claimElement.references; let ind=index">
                                    <a *ngIf="reference.source" href="{{reference.source}}" target="_blank">{{reference.source}}</a>
                                    <span *ngIf="reference.source && ind != claimElement.references.length - 1">, </span>
                                </ng-container>
                            </div>
                        </div>
                        <button class="expand-btn" (click)="toggleExpand(i, 'infringement')">
                            <ng-container *ngIf="isExpanded[i].infringement==false">

                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M20.25 11.25H24.75V15.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M15.75 24.75H11.25V20.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M24.75 11.25L19.5 16.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.25 24.75L16.5 19.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </ng-container>
                            <ng-container *ngIf="isExpanded[i].infringement==true">
                                 <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M24 16.5L19.5 16.5L19.5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 19.5L16.5 19.5L16.5 24" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19.5 16.5L24.75 11.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.5 19.5L11.25 24.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </ng-container>
                  
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>